import actionTypes from "../../actions/actionTypes";
import updateObject from "../../../utils/updateObject";

const initialState = {
  fetching: true,
  data: {},
  error: null
};

const fetch = (state, action) => {
  return updateObject(state, initialState);
}

const fetchOk = (state, action) => {
  return updateObject(state, {
    fetching: false,
    error: null,
    data: action.data
  });
}

const fetchError = (state, action) => {
  return updateObject(state, {
    fetching: false,
    data: {},
    error: action.error
  });
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.billingInformation.FETCH:
      return fetch(state, action);
    case actionTypes.billingInformation.FETCH_OK:
      return fetchOk(state, action);
    case actionTypes.billingInformation.FETCH_ERROR:
      return fetchError(state, action);
    default:
      return state;
  }
}
